import { History } from 'history';
import { Dispatch } from 'redux';
import { TcsmEpiApiState } from '../../../../../../root/tcsm-model';

export abstract class PlanAdoptionWizard {

	readonly dispatch: Dispatch<any>;

	readonly history: History<unknown>;

	readonly epiContent: TcsmEpiApiState;

	constructor(dispatch: Dispatch<any>, history: History<unknown>, epiContent: TcsmEpiApiState) {
		this.dispatch = dispatch;
		this.history = history;
		this.epiContent = epiContent;
	}

	abstract getFormValidationSchema();

	abstract getFormInitialValue();

	abstract getFormContentModel();

}